import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-claim-detail',
  templateUrl: './claim-detail.component.html',
  styleUrls: ['./claim-detail.component.css']
})
export class ClaimDetailComponent{
  status = ''
  claimDetails: any

  constructor(
    private dataservice: DataService
  ) {}

  ngOnInit(): void {
    this.claimDetails = this.dataservice.getData()
    console.log(this.claimDetails)
    this.status = this.claimDetails.status
  }
}
